import OriginTracing from '@atlassiansox/origin-tracing';

import { useCanUpgradeAndPayForProductUser } from '@confluence/experiment-more-product-users-can-upgrade-pay';

import { useGetChangeOfferingAddPaymentLink } from './useGetChangeOfferingAddPaymentLink';

const START_FREE_TRIAL_FALLBACK = '/admin/billing';

export const useModalCTALinkFree = (skip?: boolean) => {
	const origin = new OriginTracing({ product: 'confluence' });

	const {
		canUpgradeAndPayForProductUser: isEligibleForMpuFree,
		loading: mpuFreeLoading,
		error,
	} = useCanUpgradeAndPayForProductUser(skip);

	const { loading: billingUrlsLoading, changeOfferingLink } = useGetChangeOfferingAddPaymentLink({
		skip,
		isProductUser: isEligibleForMpuFree,
		isTrial: false,
	});

	const loading = mpuFreeLoading || billingUrlsLoading;

	const startFreeTrialLink = changeOfferingLink || START_FREE_TRIAL_FALLBACK;

	return {
		loading,
		error,
		startFreeTrialCtaLink: origin.addToUrl(startFreeTrialLink),
	};
};
